import React from 'react';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { useMonthNavigation } from '@src/domains/scheduling/hooks/useMonthNavigation';
import useThemeTokenColor from '@src/hooks/useThemeTokenColor';
import type { DateView } from '@src/domains/scheduling/hooks/types';
import { MonthArrowButton, MonthHeaderRoot, MonthLabelChipButton, MonthLabelText } from './styles';

type MonthYearHeaderProps = {
  currentMonth: Date;
  onMonthChange: (month: Date, direction: 'left' | 'right') => void;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
  view?: DateView;
  views?: readonly DateView[];
  onViewChange?: (view: DateView) => void;
};

const MonthYearHeader = (props: MonthYearHeaderProps) => {
  const {
    currentMonth,
    onMonthChange,
    minDate,
    maxDate,
    disabled,
    view = 'day',
    views = ['day'],
    onViewChange,
  } = props;
  const iconColor = useThemeTokenColor('text-color-neutral-strongest');

  const { label, isPrevDisabled, isNextDisabled, labelInteractive, handlePrev, handleNext, handleLabelClick } =
    useMonthNavigation({
      currentMonth,
      view,
      views,
      minDate,
      maxDate,
      disabled,
      onMonthChange,
      onViewChange,
    });

  return (
    <MonthHeaderRoot>
      <MonthArrowButton disabled={isPrevDisabled} onClick={handlePrev} aria-label='previous-month-year'>
        <IconChevronLeft size={16} stroke={2.5} color={iconColor} />
      </MonthArrowButton>
      <MonthLabelChipButton
        type='button'
        interactive={labelInteractive}
        onClick={labelInteractive ? handleLabelClick : undefined}
        aria-label='month-year-button'
      >
        <MonthLabelText>{label}</MonthLabelText>
      </MonthLabelChipButton>
      <MonthArrowButton disabled={isNextDisabled} onClick={handleNext} aria-label='next-month-year'>
        <IconChevronRight size={16} stroke={2.5} color={iconColor} />
      </MonthArrowButton>
    </MonthHeaderRoot>
  );
};

export default MonthYearHeader;
